import { render, staticRenderFns } from "./CardDingo.vue?vue&type=template&id=399f1973&"
import script from "./CardDingo.vue?vue&type=script&lang=js&"
export * from "./CardDingo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports